"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.predefinedWebsiteMixins = void 0;
const websiteTypographyMixin_1 = require("./websiteTypographyMixin");
exports.predefinedWebsiteMixins = {
    headlines: {
        xxxxl: {
            contrastInvert: (0, websiteTypographyMixin_1.websiteTypographyMixin)('headlines', 'xxxxl', 'contrastInvert'),
            bold: (0, websiteTypographyMixin_1.websiteTypographyMixin)('headlines', 'xxxxl', 'bold'),
        },
        xxxl: {
            contrastInvert: (0, websiteTypographyMixin_1.websiteTypographyMixin)('headlines', 'xxxl', 'contrastInvert'),
            bold: (0, websiteTypographyMixin_1.websiteTypographyMixin)('headlines', 'xxxl', 'bold'),
        },
        xl: {
            contrastInvert: (0, websiteTypographyMixin_1.websiteTypographyMixin)('headlines', 'xl', 'contrastInvert'),
            bold: (0, websiteTypographyMixin_1.websiteTypographyMixin)('headlines', 'xl', 'bold'),
        },
        lg: {
            contrastInvert: (0, websiteTypographyMixin_1.websiteTypographyMixin)('headlines', 'lg', 'contrastInvert'),
            bold: (0, websiteTypographyMixin_1.websiteTypographyMixin)('headlines', 'lg', 'bold'),
        },
        md: {
            contrastInvertBold: (0, websiteTypographyMixin_1.websiteTypographyMixin)('headlines', 'md', 'contrastInvertBold'),
            bold: (0, websiteTypographyMixin_1.websiteTypographyMixin)('headlines', 'md', 'bold'),
            contrastInvert: (0, websiteTypographyMixin_1.websiteTypographyMixin)('headlines', 'md', 'contrastInvert'),
            regular: (0, websiteTypographyMixin_1.websiteTypographyMixin)('headlines', 'md', 'regular'),
        },
        sm: {
            contrastInvert: (0, websiteTypographyMixin_1.websiteTypographyMixin)('headlines', 'sm', 'contrastInvert'),
            bold: (0, websiteTypographyMixin_1.websiteTypographyMixin)('headlines', 'sm', 'bold'),
        },
    },
    brandText: {
        lg: {
            contrastInvert: (0, websiteTypographyMixin_1.websiteTypographyMixin)('brandText', 'lg', 'contrastInvert'),
            bold: (0, websiteTypographyMixin_1.websiteTypographyMixin)('brandText', 'lg', 'bold'),
            regular: (0, websiteTypographyMixin_1.websiteTypographyMixin)('brandText', 'lg', 'regular'),
        },
        sm: {
            contrastInvert: (0, websiteTypographyMixin_1.websiteTypographyMixin)('brandText', 'sm', 'contrastInvert'),
            bold: (0, websiteTypographyMixin_1.websiteTypographyMixin)('brandText', 'sm', 'bold'),
            accentCoral: (0, websiteTypographyMixin_1.websiteTypographyMixin)('brandText', 'sm', 'accentCoral'),
        },
        xs: {
            contrastInvert: (0, websiteTypographyMixin_1.websiteTypographyMixin)('brandText', 'xs', 'contrastInvert'),
            regular: (0, websiteTypographyMixin_1.websiteTypographyMixin)('brandText', 'xs', 'regular'),
        },
    },
};
//# sourceMappingURL=predefinedWebsiteMixins.js.map